// Shared row / badge looks of the login reminder window.
export const ITEM = 'tw-flex tw-min-w-0 tw-items-center tw-gap-2 tw-rounded-xl tw-bg-slate-500/[0.05] tw-px-3.5 tw-py-2.5 tw-text-sm tw-text-slate-800 dark:tw-bg-white/[0.04] dark:tw-text-slate-100';
export const BADGE_BASE = 'tw-ml-auto tw-shrink-0 tw-whitespace-nowrap tw-rounded-full tw-px-2 tw-py-0.5 tw-text-[11px] tw-font-semibold';
export const BADGE = {
  urgent: 'tw-bg-rose-500/15 tw-text-rose-700 dark:tw-text-rose-300',
  warning: 'tw-bg-amber-400/20 tw-text-amber-800 dark:tw-text-amber-200',
  info: 'tw-bg-sky-500/15 tw-text-sky-800 dark:tw-text-sky-200',
  neutral: 'tw-bg-slate-500/10 tw-text-slate-600 dark:tw-text-slate-300',
};
